import { useMediaQuery, type PaletteMode } from '@mui/material';
import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

const colorModeAtom = atomWithStorage<PaletteMode | null>('preferredColorMode', null);

export const useColorMode = () => {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const [mode, setMode] = useAtom(colorModeAtom);

  return { mode: mode ?? (prefersDarkMode ? 'dark' : 'light'), setMode };
};
